<template>
  <div class="container-list">
    <div class="common-page common-head">
      <div class="common-page common-head-title">
        <i class="icon-tr--detailed" style="padding-right: 5px"></i>
        角色管理
      </div>
      <!--            <div class="common-page common-head-end" @click="$router.back()">-->
      <!--                <i class="icon-tr-sign-out"></i>-->
      <!--            </div>-->
    </div>
    <div class="common-page common-body">
      <div class="common-page common-tool-bar">
        <div class="btn" @click="showDia = true">
          <i class="icon-tr-search"></i>查询
        </div>
        <router-link class="btn ml20" to="/power/role-add"
          ><i class="icon-tr-newly-added"></i>新增</router-link
        >
      </div>
      <div class="common-page common-list">
        <el-table :data="list" class="">
          <el-table-column prop="role_value" label="角色名" align="center">
          </el-table-column>
          <el-table-column prop="role_key" align="center" label="角色编码">
          </el-table-column>
          <el-table-column prop="role_type" align="center" label="角色分类">
          </el-table-column>
          <el-table-column prop="role_data" align="center" label="数据范围">
          </el-table-column>
          <el-table-column prop="company_id" align="center" label="所属公司">
          </el-table-column>
          <el-table-column prop="remark" align="center" label="备注">
          </el-table-column>

          <el-table-column prop="STATUS" align="center" label="状态">
            <template slot-scope="scope">
              {{ $map.menuStatus[scope.row.STATUS] }}
            </template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="160px">
            <template slot-scope="scope">
              <router-link
                :to="{
                  path: '/power/role-add',
                  query: { id: scope.row.role_key },
                }"
              >
                <el-button type="warning" size="mini" plain>编辑</el-button>
              </router-link>
              <!--                            <el-popconfirm title="确定此操作吗？" class="cursor" @onConfirm="changeStatus(scope.row)">-->
              <!--                                <a slot="reference" class="red" v-if="scope.row.STATUS==1">-->
              <!--                                    停用-->
              <!--                                </a>-->
              <!--                                <a slot="reference" class="blue" v-if="scope.row.STATUS!=1">-->
              <!--                                    开启-->
              <!--                                </a>-->
              <!--                            </el-popconfirm>-->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <el-pagination
        background
        layout="prev, pager, next"
        :page-size="params.limit || 10"
        @current-change="pageChange"
        :total="total"
      >
      </el-pagination>
    </div>

    <el-dialog
      title="查询"
      :visible.sync="showDia"
      :close-on-click-modal="false"
    >
      <fm-generate-form
        :data="searchForm"
        :remote="remoteFuncs"
        :value="editData"
        ref="searchForm"
      >
      </fm-generate-form>
      <div class="center">
        <el-button type="primary" @click="searchSubmit" size="small"
          >确定</el-button
        >
        <el-button @click="cancle" size="small">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { get, post } from "@/utils/http.js";
export default {
  data() {
    return {
      list: [],
      params: { page: 1, limit: 10 },
      total: 0,
      showDia: false,
      searchForm: this.$getForm("roleSearch"),
      editData: {},
      remoteFuncs: {
        getSelect(resolve) {
          post("/user/manageTypeAndState").then((res) => {
            resolve(res.data.type);
          });
        },
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    changeStatus(it) {
      it.STATUS = it.STATUS == 1 ? 0 : 1;
      this.$post("/role/updaterole", it).then((res) => {
        // this.$message.success("操作成功");
        this.$message({
									message: "操作成功",
									type: 'success',
									duration: 700,
								});
        this.getList();
      });
    },
    cancle() {
      this.showDia = false;
      this.resetSearch();
    },
    getList() {
      this.$post("/role/findroleandmh", this.params)
        .then((res) => {
          this.total = res.data.count;
          this.list = res.data.list;
        })
        .catch((err) => {});
    },
    pageChange(val) {
      this.params.page = val;
      this.getList();
    },
    searchSubmit() {
      this.$refs.searchForm
        .getData()
        .then((data) => {
          //log(data)
          this.params = { ...this.params, ...data };
          this.params.page = 1;

          this.getList();
          this.showDia = false;
        })
        .catch((e) => {});
    },
    resetSearch() {
      this.$refs.searchForm.reset();
      this.params = { ...this.params, ...this.$refs.searchForm.models };
      this.params.page = 1;

      this.getList();
    },
  },
};
</script>

<style scoped></style>
